<template>
  <div id="app" class="no-scrollbar" :class="{'has-footer': footerVisible}">
    <!-- 全局dialog -->
    <v-dialog width="80%" />

    <!-- router-view -->
    <router-view />

    <!-- 全局footer -->
    <Footer class="app-footer" v-if="footerVisible" />
  </div>
</template>
<script>
import Footer from '@/components/basic/footer';
export default {
  name: 'App',
  components: {
    Footer
  },
  data() {
    return {
      routerIncludeFooter: [
        'home',
        'mycourse',
        'profession',
        'course',
        'center'
      ]
    };
  },
  computed: {
    footerVisible() {
      return (
        this.$lodash.indexOf(this.routerIncludeFooter, this.$route.name) != -1
      );
    }
  },
  created() {
    // TOKEN存在则默认为已登录,
    // 设置全局为登录状态,
    // 若在AJAX接口里返回401则会设置全局为未登录状态
    this.$store.commit('setlogin', !!this.$cookie.get('uooc_auth'));
  }
};
</script>
<style>
/* 清除滚动条 */
.no-scrollbar::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.app-footer {
  width: 100%;
  height: 0.98rem;
  position: fixed;
  bottom: 0;
}
.has-footer {
  padding-bottom: 0.98rem;
}

#sc * .ali-ele * {
  box-sizing: content-box;
}

#sc .sm-btn,
.ali-ele .sm-btn {
  border: 1px solid rgba(247, 247, 247, 1);
  background: rgba(247, 247, 247, 1);
}

/* 优惠券  */
.coupon-btn-title {
  text-align: center;
  margin: 10px 0;
}
.coupon-btn-title span {
  display: inline-block;
  height: 35px;
  line-height: 35px;
  width: 140px;
  font-size: 14px;
  color: #fff;
  background: #169bd4;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue